<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <base-page-layout ref="base-page" :title="$t('campanhas.resultados_campanha')" :hide-breadcrumbs="$getFirstValue()">
      <results-header
        :campaign="campanha"
        :cards-keys="campaignCardsKeys"
        :offer-type="offerType"
        :show-settings-button="!isZeDeliveryCampaign"
        @settings-button="redirectToSettings"
      />

      <v-row v-if="isZeDeliveryCampaign">
        <v-col>
          <div class="d-flex flex-column mb-4">
            <span class="text-cinza-d10 text-18 mt-3 mb-1">Período Analisado</span>
            <span class="text-cinza-0 text-14">
              Os resultados das campanhas do Zé Delivery são exibidos por mês, selecione o mês que deseja visualizar os resultados abaixo.
            </span>
          </div>
          <month-range-picker :analysed-period.sync="analysedPeriod" :min="minAnalyticPeriod" :max="maxAnalyticPeriod" />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-end pt-5">
          <export-report-by-unit :franchise="queryParamFranchise" :offer-sales-type="rawFirstOfferType" />
        </v-col>
      </v-row>

      <benefit-big-numbers v-if="isZeDeliveryCampaign" :current-metrics="currentZeMetrics" :previous-metrics="previousZeMetrics" :loading="$apollo.loading" />

      <v-row v-if="!isZeDeliveryCampaign">
        <v-col cols="3">
          <results-revenue-card :metrics="campaignMetricsOfferType" :loading="$apollo.loading" is-mercapromo :offer-type="offerType" />
        </v-col>
        <v-col v-if="!isDigitalVoucherCampaign" cols="3">
          <rebate-card :metrics="rebateMetrics" :loading="$apollo.loading" :offer-type="offerType" />
        </v-col>
        <v-col cols="3">
          <results-first-purchase-card :metrics="campaignMetricsOfferType" :loading="$apollo.loading" />
        </v-col>
        <v-col cols="3">
          <results-average-ticket-card :metrics="campaignMetricsOfferType" :loading="$apollo.loading" is-mercapromo :offer-type="offerType" />
        </v-col>
        <v-col v-if="isDigitalVoucherCampaign" cols="3">
          <eligible-units-card :metrics="campaignMetricsOfferType" :loading="$apollo.loading" />
        </v-col>
      </v-row>

      <v-row v-if="isCashbackCampaign || isDigitalVoucherCampaign || isZeDeliveryCampaign">
        <v-col :cols="isZeDeliveryCampaign ? 12 : 8">
          <benefit-group-card
            :metrics="isZeDeliveryCampaign ? currentZeMetrics : campaignMetricsOfferType"
            :rebate-metrics="isZeDeliveryCampaign ? currentZeRebateMetrics : rebateMetrics"
            :loading="$apollo.loading"
            :offer-type="offerType"
          />
        </v-col>
        <v-col v-if="!isZeDeliveryCampaign" cols="4">
          <benefit-progress-card :metrics="campaignMetricsOfferType" :loading="$apollo.loading" :offer-type="offerType" />
        </v-col>
      </v-row>

      <uplift-data
        v-if="!isZeDeliveryCampaign"
        :offer-type="offerType"
        :products="offerTypeProducts"
        :loading="$apollo.loading"
        :metrics="campaignMetricsOfferType"
        :periods="periods"
        :units="offerScheduleCampaign.units"
      ></uplift-data>

      <v-row v-if="!isZeDeliveryCampaign">
        <v-col cols="12">
          <coupons-funnel-bar
            :loading="$apollo.loading"
            :metrics="campaignMetricsOfferType"
            :offer-type="offerType"
            :unit-metrics="unitMetrics"
            :start-date="campanha.start_date"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <sales-per-unit :metrics="isZeDeliveryCampaign ? zeUnitMetrics : unitMetrics" :offer-type="offerType" />
        </v-col>
      </v-row>

      <v-row v-if="isZeDeliveryCampaign">
        <v-col>
          <benefit-coupons-table :metrics="currentZeMetrics" :coupons="campanha.benefits_offer_sales[0].coupons" />
        </v-col>
      </v-row>

      <v-row v-if="!isZeDeliveryCampaign">
        <v-col>
          <funnel
            :loading="$apollo.loading"
            :metrics="campaignMetricsOfferType"
            :base-metric="modelOfCampaign"
            :campaign="campanha"
            :hide-quick-action-from-franchisee="hideQuickActionFromFranchisee"
            is-mercapromo
          />
        </v-col>
      </v-row>

      <v-row v-if="isZeDeliveryCampaign">
        <v-col>
          <benefit-trigger-products-table :products="zeProducts" :current-metrics="currentZeMetrics" :previous-metrics="previousZeMetrics" />
        </v-col>
      </v-row>

      <v-row v-if="isCrossSellCampaign">
        <v-col cols="12">
          <trigger-products-table :metrics="campaignMetricsOfferType" :trigger-products="triggerProducts" />
        </v-col>
      </v-row>

      <v-row v-if="isCrossSellCampaign">
        <v-col cols="12">
          <target-products-table :metrics="campaignMetricsOfferType" :target-products="targetProducts" :rebate-metrics="rebateMetrics" />
        </v-col>
      </v-row>

      <v-row v-if="!isCrossSellCampaign && !isZeDeliveryCampaign">
        <v-col cols="12">
          <products-table
            :loading="$apollo.loading"
            :metrics="campaignMetricsOfferType"
            :rebate-metrics="rebateMetrics"
            :offer-schedule="offerScheduleCampaign"
            base-metric="sales"
            :campaign-model="modelOfCampaign"
            show-discounts
            :currentOfferTypeKeyName="offerType"
            :hide-quick-action-from-franchisee="hideQuickActionFromFranchisee"
            :is-industry-campaign="Boolean(this.campanha.industry)"
            is-mercapromo-campaign
          />
        </v-col>
      </v-row>

      <mf-action-buttons
        :cancel-button="{
          text: 'Fechar',
          action: backToOffersList,
          isVisible: true,
          isDisabled: false,
        }"
      />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ResultsHeader from '@/components/campaigns/ResultsHeader.vue'
import { QUERY_SALES_CAMPAIGN_RESULTS_BY_ID } from '@/modules/campanhas/gestao-ofertas-v2/graphql'
import { getOfferTypeName } from '@/modules/campanhas/gestao-ofertas-v2/helpers/offerType.js'
import { DateTime } from 'luxon'
import { assertArray, localeString } from '@/config/helpers.js'
import { offerSalesTabs } from '@/modules/campanhas/gestao-ofertas-v2/views/mixins/offer-sales-tabs'
import { mergeAllIndividualAndGroupProductsByOffer, mergeAllComboProducts } from '@/modules/campanhas/gestao-ofertas-v2/helpers/products.js'
import UpliftData from '@/modules/campanhas/gestao-ofertas-v2/views/components/UpliftData.vue'

export default {
  name: 'ResultsMercapromo',
  components: {
    BasePageLayout,
    ResultsHeader,
    UpliftData,
    CouponsFunnelBar: () => import('@/modules/industria/ofertas-trade/views/components/coupons-funnel/CouponsFunnelBar.vue'),
    SalesPerUnit: () => import('@/modules/industria/ofertas-trade/views/components/sales-per-unit/SalesPerUnit.vue'),
    ResultsRevenueCard: () => import('@/modules/industria/ofertas-trade/views/components/ResultsRevenueCard.vue'),
    RebateCard: () => import('@/modules/industria/ofertas-trade/views/components/RebateCard.vue'),
    ResultsAverageTicketCard: () => import('@/modules/industria/ofertas-trade/views/components/ResultsAverageTicketCard.vue'),
    ResultsFirstPurchaseCard: () => import('@/modules/industria/ofertas-trade/views/components/ResultsFirstPurchaseCard.vue'),
    EligibleUnitsCard: () => import('@/modules/industria/ofertas-trade/views/components/EligibleUnitsCard.vue'),
    ProductsTable: () => import('@/modules/campanhas/views/components/results/ProductsTable.vue'),
    Funnel: () => import('@/modules/campanhas/views/components/results/Funnel.vue'),
    BenefitGroupCard: () => import('@/modules/industria/ofertas-trade/views/components/BenefitGroupCard.vue'),
    BenefitProgressCard: () => import('@/modules/industria/ofertas-trade/views/components/BenefitProgressCard.vue'),
    TriggerProductsTable: () => import('@/modules/industria/ofertas-trade/views/components/TriggerProductsTable.vue'),
    TargetProductsTable: () => import('@/modules/industria/ofertas-trade/views/components/TargetProductsTable.vue'),
    MonthRangePicker: () => import('@/modules/empresa/dre/views/components/MonthRangePicker.vue'),
    BenefitBigNumbers: () => import('@/modules/industria/ofertas-trade/views/components/ze-delivery/BenefitBigNumbers.vue'),
    BenefitCouponsTable: () => import('@/modules/industria/ofertas-trade/views/components/ze-delivery/BenefitCouponsTable.vue'),
    BenefitTriggerProductsTable: () => import('@/modules/industria/ofertas-trade/views/components/ze-delivery/BenefitTriggerProductsTable.vue'),
    ExportReportByUnit: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/ExportReportByUnit.vue'),
  },
  mixins: [offerSalesTabs],
  data: () => ({
    locale: localeString,
    campanha: {
      name: '',
      description: '',
      eans: [],
      start_date: '',
      end_date: '',
      offer_sales: [],
      active: false,
      segments: [],
      activatable: false,
      industry: null,
      types: [],
    },
    campaignCardsKeys: ['validity-period', 'campaign-template', 'campaign-industry', 'target'],
    DateTime: DateTime,
    analysedPeriod: DateTime.now().toFormat('yyyy-MM'),
    minAnalyticPeriod: '',
    maxAnalyticPeriod: DateTime.now().toFormat('yyyy-MM'),
  }),
  computed: {
    isFranchisee() {
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },

    hideQuickActionFromFranchisee() {
      return this.isFranchisee && this.$route.query.franchise
    },

    queryParamFranchise() {
      return typeof this.$route.query.franchise === 'string' ? this.$route.query.franchise === 'true' : this.$route.query.franchise
    },

    zeProducts() {
      return this.campanha?.benefits_offer_sales[0].trigger_products
    },

    currentZeMetrics() {
      return this.campanha?.month_metrics?.find((metric) => metric.month === this.analysedPeriod)?.metrics?.benefits || {}
    },

    currentZeRebateMetrics() {
      return this.campanha?.rebate_metrics?.data?.[this.offerType]?.month_metrics?.find((monthMetric) => monthMetric.id === this.analysedPeriod) || {}
    },

    previousZeMetrics() {
      const previousMonth = DateTime.fromISO(this.analysedPeriod).minus({ months: 1 })
      return this.campanha?.month_metrics?.find((metric) => metric.month === previousMonth.toFormat('yyyy-MM'))?.metrics?.benefits || {}
    },

    campaignMetricsOfferType() {
      return this.campanha?.metrics?.[this.offerType]
    },

    offerType() {
      return this.campanha.types && this.campanha.types.length > 0 ? getOfferTypeName(this.campanha.types[0]) : null
    },

    rawFirstOfferType() {
      if (this.campanha.types) return this.campanha.types[0]
      return null
    },

    isCashbackCampaign() {
      return this.offerType === 'nextbuycashback'
    },

    isDigitalVoucherCampaign() {
      return this.offerType === 'dynamic_rule'
    },

    isCrossSellCampaign() {
      return this.offerType === 'crosssell'
    },

    isZeDeliveryCampaign() {
      return this.offerType === 'benefits'
    },

    zeUnitMetrics() {
      return this.campanha?.month_metrics?.find((metric) => metric.month === this.analysedPeriod)?.unit_metrics || []
    },

    unitMetrics() {
      return this.campanha?.unit_metrics
    },

    rebateMetrics() {
      return this.campanha?.rebate_metrics?.data?.[this.offerType]
    },

    offerScheduleCampaign() {
      return {
        _id: this.campanha._id,
        name: this.campanha.name,
        units: this.campanha.units,
      }
    },

    modelOfCampaign() {
      return this.campanha.activatable ? 'activatable' : 'sales'
    },

    triggerProducts() {
      return this.campanha.cross_sell_offer_sales[0].trigger_products || []
    },

    targetProducts() {
      return this.campanha.cross_sell_offer_sales[0].target_products || []
    },

    periods() {
      return {
        offered: {
          startDate: this.campanha?.start_date,
          endDate: this.campanha?.end_date,
        },
        previous: {
          startDate: this.campanha?.reference_period_metrics?.start_date,
          endDate: this.campanha?.reference_period_metrics?.end_date,
        },
      }
    },
    offerTypeProducts() {
      if (!this.offerTypeResultsCurrentTabDetails?.keyName) {
        // Nextbuycashback and dynamic rule
        // have a special case because the logic in offerTypeResultsCurrentTabDetails
        // does not work for them
        if (this.campanha.next_buy_cashback_offer_sales?.length) {
          return mergeAllIndividualAndGroupProductsByOffer(this.campanha.next_buy_cashback_offer_sales, 'next_buy_cashback_offer_sales')
        } else if (this.campanha.dynamic_rule_offer_sales?.length) {
          return assertArray(this.campanha.dynamic_rule_offer_sales).reduce((productList, product) => {
            productList.push(...mergeAllComboProducts(product.trigger_products, 'trigger_products'))
            return productList
          }, [])
        }
        return []
      }
      if (this.offerTypeResultsCurrentTabDetails?.keyName === 'combo_offer_sales') {
        return assertArray(this.campanha.combo_offer_sales).reduce((productList, product) => {
          productList.push(...mergeAllComboProducts(product.target_products, 'target_products'))
          productList.push(...mergeAllComboProducts(product.trigger_products, 'trigger_products'))
          return productList
        }, [])
      }

      return mergeAllIndividualAndGroupProductsByOffer(
        this.campanha[this.offerTypeResultsCurrentTabDetails?.keyName],
        this.offerTypeResultsCurrentTabDetails?.keyName
      )
    },
  },
  apollo: {
    campanha: {
      query: QUERY_SALES_CAMPAIGN_RESULTS_BY_ID,
      variables() {
        const { id } = this.$route.params
        const franchise = this.queryParamFranchise
        const data = { id }
        data.franchise = franchise
        return data
      },
      context() {
        return {
          uri: this.$microservicesUrls['sales'],
        }
      },
      update({ offerSchedule }) {
        this.minAnalyticPeriod = DateTime.fromISO(offerSchedule?.start_date).toFormat('yyyy-MM')
        return offerSchedule
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    },
  },
  methods: {
    backToOffersList() {
      this.$router.push({ name: 'ofertas-trade-historico' }).catch(() => {})
    },
    redirectToSettings(path) {
      this.$router.push(path).catch(() => {})
    },
  },
}
</script>

<style lang="scss">
.alert-color {
  background-color: #fff9e3 !important;
  margin-bottom: 0;
}

.text-cinza-d10 {
  color: $cinza-d10;
}

.text-cinza-0 {
  color: $cinza-0;
}

.text-18 {
  font-size: 18px;
  font-weight: bold;
}

.text-14 {
  font-size: 14px;
}

.mercapromo-report {
  width: 100%;
  height: 1196px;
}

.analysed-period-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
</style>
